<div class="wrap-rounded-link">
  <app-rounded-link
    *ngFor="let item of list"
    color="primary"
    [link]="item.link"
    [icon]="item.icon"
    squareMode="true"
    [type]="'SMALL'"
    [text]="item.title"
    [kpi]="item.kpi"
    showKpi="true"
    appTooltip="{{ 'MenuTooltips.' + item.id | translate }}"
  ></app-rounded-link>
</div>

<div class="prop-summary row">
  <div *ngIf="buildingData.length > 0" class="property-form-group col-lg-6">
    <app-property-attribute-card
      title="Construction"
      [data]="buildingData"
      [linkRouterParams]="['/property', prop.uid, 'building']"
      tooltip="Voir tous les éléments"
      noContent="Aucun élément n'est renseigné."
    ></app-property-attribute-card>
  </div>
  <div *ngIf="energyData.length > 0" class="property-form-group col-lg-6">
    <app-property-attribute-card
      title="Énergie"
      [data]="energyData"
      [linkRouterParams]="['/property', prop.uid, 'energy']"
      tooltip="Voir tous les éléments"
      noContent="Aucun élément n'est renseigné."
    ></app-property-attribute-card>
  </div>
  <div *ngIf="financialData.length > 0" class="property-form-group col-lg-6">
    <app-property-attribute-card
      title="Finance"
      [data]="financialData"
      [linkRouterParams]="['/property', prop.uid, 'financial']"
      tooltip="Voir tous les éléments"
      noContent="Aucun élément n'est renseigné."
    ></app-property-attribute-card>
  </div>
  <div *ngIf="zoneInfoData.length > 0" class="property-form-group col-lg-6">
    <app-property-attribute-card
      title="Informations de zone"
      [data]="zoneInfoData"
      [linkRouterParams]="['/property', prop.uid, 'location']"
      tooltip="Voir la localisation"
      noContent="Aucun élément n'est renseigné."
    ></app-property-attribute-card>
  </div>
</div>
